import { DropZone as DropZoneComponent } from './dropzone';
import { DropZoneProvider, useDropZone } from './dropzone-provider';
import { DropZoneSelectedFiles } from './dropzone-selected-files';

const DropZone = Object.assign(DropZoneComponent, {
  SelectedFiles: DropZoneSelectedFiles,
  Provider: DropZoneProvider,
});

export { DropZone, useDropZone };
